import React from "react";
import Button from "../../../components/ui/Button";
import { motion } from "framer-motion";
import {
  FaArrowRight,
  FaCheck,
  FaGraduationCap,
  FaEarthAmericas,
} from "react-icons/fa6";
import { CONSULTATION_URL } from "../../../../../routes/data";

const AcademyCTA = () => {

  return (
    <>
      <section className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="relative overflow-hidden bg-white-f9 border border-gray-100 rounded-3xl shadow-sm lg:grid lg:grid-cols-2 lg:gap-4 p-8 sm:p-12 lg:p-0">
            {/* Left: The Visual Stack */}
            <div className="relative h-[400px] lg:h-auto min-h-[400px] flex items-center justify-center lg:py-12 order-last lg:order-first">
              {/* Background Glow */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-blue-100/60 rounded-full blur-3xl" />

              {/* Main Card: Admission Status */}
              <motion.div
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6 }}
                className="relative z-10 bg-white w-[280px] rounded-2xl shadow-xl border border-gray-100 p-6 flex flex-col gap-4"
              >
                <div className="flex items-center gap-3 border-b border-gray-50 pb-4">
                  <div className="h-10 w-10 bg-blue-00 rounded-full flex items-center justify-center text-white text-lg font-bold">
                    SV
                  </div>
                  <div>
                    <p className="text-sm font-bold text-gray-900">
                      Admission Status
                    </p>
                    <p className="text-xs text-gray-500">Updated just now</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-green-50 rounded-xl border border-green-100">
                    <span className="text-sm font-medium text-green-800">
                      University Offer
                    </span>
                    <FaCheck className="text-green-600" />
                  </div>
                  <div className="flex items-center justify-between p-3 bg-blue-50 rounded-xl border border-blue-100">
                    <span className="text-sm font-medium text-blue-800">
                      Visa Application
                    </span>
                    <span className="text-xs font-bold bg-blue-200 text-blue-800 px-2 py-0.5 rounded-full">
                      Processing
                    </span>
                  </div>
                </div>

                <div className="mt-2 text-center">
                  <p className="text-xs text-gray-400 font-medium">
                    Acceptance Probability: High
                  </p>
                </div>
              </motion.div>

              {/* Floating Chip 1: Future Student */}
              <motion.div
                animate={{ y: [-10, 10, -10] }}
                transition={{
                  repeat: Infinity,
                  duration: 4,
                  ease: "easeInOut",
                }}
                className="absolute top-12 lg:top-20 right-8 lg:right-16 z-20 bg-gray-900 text-white p-3 rounded-2xl shadow-lg border border-gray-700 flex items-center gap-3 pr-5"
              >
                <div className="h-8 w-8 bg-purple-500 rounded-lg flex items-center justify-center">
                  <FaGraduationCap className="text-white text-sm" />
                </div>
                <div>
                  <p className="text-[10px] text-gray-400 uppercase font-bold">
                    Acceptance
                  </p>
                  <p className="text-sm font-bold text-purple-200">Confirmed</p>
                </div>
              </motion.div>

              {/* Floating Chip 2: Global Reach */}
              <motion.div
                animate={{ y: [10, -10, 10] }}
                transition={{
                  repeat: Infinity,
                  duration: 5,
                  ease: "easeInOut",
                  delay: 1,
                }}
                className="absolute bottom-12 lg:bottom-24 left-4 lg:left-12 z-20 bg-white p-3 rounded-2xl shadow-lg border border-gray-100 flex items-center gap-3 pr-5"
              >
                <div className="h-8 w-8 bg-green-100 rounded-lg flex items-center justify-center">
                  <FaEarthAmericas className="text-green-600" />
                </div>
                <div>
                  <p className="text-[10px] text-gray-400 uppercase font-bold">
                    Destinations
                  </p>
                  <p className="text-sm font-bold text-gray-900">USA, UK, CA</p>
                </div>
              </motion.div>
            </div>

            {/* Right: Content & CTA */}
            <div className="flex items-center justify-center lg:justify-start lg:pr-12 lg:py-12 order-first lg:order-last">
              <div className="max-w-md text-center lg:text-left">
                <h2 className="text-3xl font-light font-spartan tracking-tight text-gray-900 sm:text-4xl leading-[1.4]">
                  Ready to{" "}
                  <span className="text-purple-600 italic mx-1">start</span>{" "}
                  your <br className="hidden lg:block" />
                  study abroad{" "}
                  <span className="text-blue-00 italic mx-1">journey?</span>
                </h2>
                <p className="mt-6 leading-8 text-gray-600">
                  Join thousands of students who have secured admissions to top
                  international universities with SeamlessVisa.
                </p>
                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-6">
                  <Button
                    label="Book A Consultation"
                    onClick={() => window.open(CONSULTATION_URL, "_blank")}
                    variant="primary"
                    size="large"
                    endIcon={<FaArrowRight />}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AcademyCTA;
